import styled from 'styled-components'

export const VisitingHoursComponent = styled.div`
  padding-bottom: 30px;

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    margin: 0 15px;
  }

  @media ${ (props) => props.theme.breakpoints.devices.min.md } {
    margin: 0;
  }
`
